import Page from "../pages/Page";
import {getApi, handleError, logout} from "~/auth";
import * as validation from "~/utils/validation";
import UI from "~/ui";
import $ from "jquery";
import {gotoDefault} from "~/utils";
import {generaRecaptcha, recaptchaReady, recaptchaToken} from "~/recaptcha";
import {t} from "~/hooks/useI18n";

class RecuperaPassword extends Page {

    private theForm: HTMLFormElement = document.getElementById("form-recuperapassword") as HTMLFormElement;

    constructor() {
        super("RecuperaPassword", "Recupera password");
    }

    private async initRecaptcha() {
        await recaptchaReady();
        let _ = generaRecaptcha('recuperapassword', true);
    }

    pageStart(): Promise<void> {
        const that = this;
        let _ = this.initRecaptcha();
        that.addValidation();
        $("#btnRecuperaPassword").on("click", function (e) {
            e.preventDefault();
            that.handleFormSubmit();
        });

        return Promise.resolve();
    }
    
    private addValidation() {
        const form = this.theForm;
        // Rimuove la classe di validazione quando l'utente modifica i campi
        form.addEventListener("input", () => {
            form.classList.remove("was-validated");
        });

        // Validatore per l'email
        const emailValidator = (inputElement: HTMLInputElement): validation.ValidationResult => {
            const email = $(inputElement).val() as string;
            if (!email) {
                return {
                    ok: false,
                    error: t("validation.required")
                };
            }
            
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            const isValid = emailRegex.test(email);

            return {
                ok: isValid,
                error: isValid ? "" : t("validation.emailInvalidFormat")
            };
        };

        const validaEmail = () => {
            validation.validate("txtEmail", emailValidator);
        };

        validation.setValidatorOnInput("txtEmail", emailValidator);

        // Validazione al submit
        this.onSubmitValidator = async () => {
            validaEmail();
        };
    }

    private onSubmitValidator: () => void = async () => {
    }
    
    /*
        * @description Funzione per gestire l'invio del form
     */
    private async handleFormSubmit(): Promise<void> {
        // Validazione del form
        this.onSubmitValidator();
        if (!this.theForm.checkValidity()) {
            this.theForm.classList.add('was-validated');
            return;
        }

        const email = $("#txtEmail").val() as string;
        let _ = this.spinner.spin();
        try { 
            await getApi().forgotPassword(email, window.BaseUrlWeb + "reimposta-password"); 
            UI.confirmOneButton(" ", t("messages.passwordResetEmailSent"), "", function (result) {
                if (result) {
                    _ = gotoDefault();
                }
            }).then((b) => {});
        } catch (e) {
            let errHtml = handleError(e);
            $("#waitmessage").html(errHtml);
        } finally {
            this.spinner.stop();
        }
    }
}

export default RecuperaPassword;